import React, { useState, useEffect } from "react";
import { Layout, theme } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../Config";
import VariationCard from "./VariationCard";
import AdvertisementCard from "./AdvertisementCard";

const { Content } = Layout;

const AppContent = () => {
  const { token } = theme.useToken();
  const [VariationData, setVariationData] = useState([]);
  const [mobile, setMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const resize = () => setMobile(window.innerWidth < 900);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  useEffect(() => {
    const fetchVariations = async () => {
      try {
        // const token = localStorage.getItem("token");

        const res = await axios.get(
          `${API_BASE_URL}/uservariations/variation-FE?limit=10`,
        );

        console.log("API RESPONSE:", res?.data);

        setVariationData(res?.data?.variations || []);
      } catch (error) {
        console.log("FETCH ERROR:", error);
      }
    };

    fetchVariations();
  }, []);
  const WisdomBanner = () => (
    <div style={{ fontFamily: "inherit", marginBottom: "2rem" }}>
      {/* Avvaiyar Quote */}
      <div
        style={{
          background: "linear-gradient(135deg, #EEEDFE, #E1F5EE)",
          borderRadius: 12,
          padding: "1.5rem",
          marginBottom: "1rem",
          borderLeft: "4px solid #534AB7",
        }}
      >
        <div
          style={{
            fontSize: 22,
            fontWeight: 500,
            color: "#3C3489",
            marginBottom: 4,
          }}
        >
          "கற்றது கை மண்ணளவு கல்லாதது உலக அளவு"
        </div>
        <div style={{ fontSize: 15, color: "#534AB7", marginBottom: 8 }}>
          — Old Tamil poet <strong>Avvaiyar</strong>
        </div>
        <div style={{ fontSize: 16, color: "#534AB7", fontStyle: "italic" }}>
          <b>Meaning:</b> What we have learned is only as small as the soil in
          our hands, what we have not learned is still as big as the world.
        </div>
      </div>

      {/* Kaniyan Quote */}
      <div
        style={{
          background: "linear-gradient(135deg, #E1F5EE, #E6F1FB)",
          borderRadius: 12,
          padding: "1.5rem",
          marginBottom: "1rem",
          borderLeft: "4px solid #0F6E56",
        }}
      >
        <div
          style={{
            fontSize: 22,
            fontWeight: 500,
            color: "#085041",
            marginBottom: 4,
          }}
        >
          "யாதும் ஊரே யாவரும் கேளிர்"
        </div>
        <div style={{ fontSize: 15, color: "#0F6E56", marginBottom: 8 }}>
          — Old Tamil poet <strong>Kaniyan Poonkundranar</strong>
        </div>
        <div style={{ fontSize: 16, color: "#085041", fontStyle: "italic" }}>
          <b>Meaning:</b> I am a global citizen, everyone in the world is my
          relative.
        </div>
      </div>

      {/* Humble Realization */}
      <div
        style={{
          background: "#FAEEDA",
          borderRadius: 12,
          padding: "1.5rem",
          marginBottom: "1rem",
          border: "0.5px solid #EF9F27",
        }}
      >
        <div
          style={{
            fontSize: 16,
            fontWeight: 500,
            color: "#633806",
            marginBottom: 8,
          }}
        >
          A Humble Realization
        </div>
        <div style={{ fontSize: 16, color: "#854F0B", lineHeight: 1.8 }}>
          I have shared what I know of yoga, yet I see my knowledge is but{" "}
          <strong>"a handful of soil."</strong> To make it truly{" "}
          <strong>"global,"</strong> we must weave together the wisdom of every
          practitioner worldwide.
          <br />
          <br />
          That is the purpose of this website: To unite the knowledge of yoga
          lovers from around the world and create a vast repository of yoga
          poses.
        </div>
      </div>

      {/* Contributions */}
      <div
        style={{
          background: "#FAECE7",
          borderRadius: 12,
          padding: "1.5rem",
          marginBottom: "1rem",
          border: "0.5px solid #D85A30",
        }}
      >
        <div
          style={{
            background: "#D85A30",
            color: "#FAECE7",
            display: "inline-block",
            fontSize: 16,
            fontWeight: 500,
            padding: "4px 12px",
            borderRadius: 6,
            marginBottom: 10,
          }}
        >
          Send in your contributions
        </div>
        <div style={{ fontSize: 16, color: "#712B13", lineHeight: 1.8 }}>
          Share the yoga pose variations, techniques, and wisdom that you know.
          <div
            style={{
              marginTop: 8,
              background: "#F5C4B3",
              borderRadius: 6,
              padding: "6px 12px",
              fontSize: 13,
              color: "#993C1D",
              fontWeight: 500,
            }}
          >
            Please send only new images that are not already on the website.
          </div>
          <a
            href="https://admin.yogarefer.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              style={{
                marginTop: 12,
                padding: "10px 24px",
                borderRadius: 8,
                cursor: "pointer",
                background: "#fff",
                color: "#D85A30",
                fontSize: 14,
                fontWeight: 700,
                border: "2px solid #D85A30",
                boxShadow: "0 2px 8px rgba(216,90,48,0.15)",
                letterSpacing: "0.03em",
              }}
            >
              Send Contributions →
            </button>
          </a>
        </div>
      </div>

      {/* Thiruvalluvar */}
      <div
        style={{
          background: "linear-gradient(135deg, #E6F1FB, #EEEDFE)",
          borderRadius: 12,
          padding: "1.5rem",
          marginBottom: "1rem",
          borderLeft: "4px solid #185FA5",
        }}
      >
        <div style={{ fontSize: 16, color: "#185FA5", marginBottom: 6 }}>
          Our Commitment to Authentic Wisdom —{" "}
          <strong>As the ancient Tamil sage Thiruvalluvar taught us,</strong>
        </div>
        <div
          style={{
            fontSize: 18,
            fontWeight: 500,
            color: "#042C53",
            marginBottom: 8,
          }}
        >
          <strong>
            எப்பொருள் யார்யார்வாய்க் கேட்பினும் அப்பொருள்
            <br />
            மெய்ப்பொருள் காண்ப தறிவு
          </strong>
        </div>
        <div style={{ fontSize: 16, color: "#0C447C", fontStyle: "italic" }}>
          <b>Meaning:</b> Regardless of who says what, true wisdom lies in not
          blindly accepting it but in investigating and discerning the truth.
        </div>
      </div>
      {/* Heartfelt Assistance */}
      <div
        style={{
          background: "#EAF3DE",
          borderRadius: 12,
          padding: "1.5rem",
          marginBottom: "1rem",
          border: "0.5px solid #97C459",
        }}
      >
        <div style={{ fontWeight: 500, color: "#173404", marginBottom: 8 }}>
          Your heartfelt assistance:
        </div>
        <div style={{ fontSize: 15, color: "#3B6D11", lineHeight: 1.8 }}>
          As Thiruvalluvar said, if you find any errors while exploring our
          website, please inform us and help us improve our global yoga
          resources!
        </div>
      </div>

      {/* Footer tagline */}
      <div
        style={{
          background: "#534AB7",
          borderRadius: 12,
          padding: "1.5rem",
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontSize: 15,
            fontWeight: 500,
            color: "#EEEDFE",
            lineHeight: 1.6,
          }}
        >
          "YogaRefer: Where every yogi finds the right reference to explore,
          understand, and innovate postures."
        </div>
      </div>
    </div>
  );

   return (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <Layout
      style={{
        marginTop: 40,
        marginLeft: mobile ? 10 : 20,
        marginRight: mobile ? 10 : 20,
        display: "flex",
        flexDirection: mobile ? "column" : "row",
        gap: 20,
      }}
    >
      <Content
        style={{
          background: token.colorBgContainer,
          borderRadius: token.borderRadiusLG,
          padding: 20,
          width: "100%",
        }}
      >
        <WisdomBanner />
        <div className="section" style={{ marginTop: "10px" }}>
          <h2 style={{ marginBottom: "20px" }}>Latest Variation Poses</h2>

          {VariationData.length === 0 ? (
            <p>No Variations Submitted</p>
          ) : (
            <div className="variation-grid">
              {VariationData.map((v, i) => (
                <VariationCard v={v} key={i} />
              ))}
            </div>
          )}
        </div>
      </Content>
    </Layout>
    <AdvertisementCard />
  </div>
);
};

export default AppContent;
